import { Textarea } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import DrawerDialog from '@/components/drawer'
import { Button } from '@/components/ui/button'
import { DrawerBody, DrawerFooter } from '@/components/ui/drawer'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'
import { IFeedbackDrawerProps } from '@/types/gigiChat/Feedback'

import Header from './components/Header'

const POSITIVE = 'positive'

const FeedbackDrawer = ({ feedbackType, comment, isOpen, onClose, onChange, handleSendFeedback, isLoading }: IFeedbackDrawerProps) => {
    const { t } = useTranslation()
    const borderColor = useColorModeValue('gray.300', 'gray.700')

    return (
        <DrawerDialog isOpen={isOpen} onClose={onClose}>
            <Header feedbackType={feedbackType || ''} />
            <DrawerBody px="0" py="24px">
                <Text fontSize={14} pb="24px" fontWeight="bold">
                    {feedbackType === POSITIVE ? t('chat.feedback.drawer.positiveContent') : t('chat.feedback.drawer.content')}
                </Text>
                {feedbackType !== POSITIVE && <Text fontSize={12}>{t('chat.feedback.drawer.textarea')}</Text>}
                <Textarea
                    mt={2}
                    onChange={(e) => onChange(e.target.value.trimStart())}
                    variant="gsk"
                    style={{ caretColor: 'var(--chakra-colors-orange-400)' }}
                    value={comment}
                    maxH="90%"
                    minH="250px"
                />
            </DrawerBody>
            <DrawerFooter borderTopWidth="1px" borderColor={borderColor} justifyContent="flex-start" px="0" py="32px">
                <Button variant="secondary" mr="18px" onClick={onClose}>
                    {t('chat.feedback.drawer.buttons.cancel')}
                </Button>
                <Button
                    variant="primary"
                    onClick={handleSendFeedback}
                    disabled={(feedbackType === POSITIVE ? !comment : false) || isLoading}
                >
                    {t('chat.feedback.drawer.buttons.send')}
                </Button>
            </DrawerFooter>
        </DrawerDialog>
    )
}

export default FeedbackDrawer
